import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
// import App from "./App";

Sentry.init({
  dsn: "https://ec74e6b7f6834daeb307cab053057e84@o118569.ingest.sentry.io/5715038",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

// ReactDOM.render(<App />, document.getElementById("root"));
